import './module/sellops-ultimate-cart';
import './extension/module/sw-order/component/sw-order-line-items-grid';

import UcCrossSellRulesApiService from './service/uc-cross-sell-rules.api.service';
import UcPaymentIconsApiService from './service/uc-payment-icons.api.service';

// Register the plugin's Cross-Sell Rules admin API service.
//
// Mirrors how core registers AclApiService in
// `src/core/service/api/acl.api.service.js`: `httpClient` comes from the
// `init` container (where it actually lives in Shopware 6.7) and
// `loginService` from the service container. Components consume it via
// `inject: ['ucCrossSellRulesApiService']`.
//
// Once registered, `ApiService.getBasicHeaders()` inside the service
// automatically attaches Authorization + sw-language-id on every request.
Shopware.Application.addServiceProvider('ucCrossSellRulesApiService', (container) => {
    const initContainer = Shopware.Application.getContainer('init');

    return new UcCrossSellRulesApiService(initContainer.httpClient, container.loginService);
});

// Same registration pattern for the Payment Provider Icons library —
// consumed via `inject: ['ucPaymentIconsApiService']`.
Shopware.Application.addServiceProvider('ucPaymentIconsApiService', (container) => {
    const initContainer = Shopware.Application.getContainer('init');

    return new UcPaymentIconsApiService(initContainer.httpClient, container.loginService);
});
